import { Button, Stack, Typography } from '@mui/material';
import { Tab } from '../types';

type EnergyHelperTextProps = {
  tab: Tab;
  onCopyFromConventional?: () => void;
  onCopyFromReduced?: () => void;
};

export const EnergyHelperText: React.FC<EnergyHelperTextProps> = ({
  tab,
  onCopyFromConventional,
  onCopyFromReduced,
}) => {
  if (tab === 'conventionalAlternative') {
    return <ConventionalHelperText />;
  }

  if (tab === 'reducedCarbonAlternative') {
    return (
      <ReducedCarbonHelperText
        onCopyFromConventional={onCopyFromConventional}
      />
    );
  }

  if (tab === 'zeroCarbonAlternative') {
    return <ZeroCarbonHelperText onCopyFromReduced={onCopyFromReduced} />;
  }
};

const ConventionalHelperText: React.FC = () => {
  return (
    <Stack px={4} spacing={4}>
      <Typography>
        Select an Internal energy production or External energy providers you
        would like to utilize in this build.
      </Typography>
      <Typography>
        Conventional builds are what you would traditionally use without
        consideration of carbon impact.
      </Typography>
    </Stack>
  );
};

type ReducedProps = {
  onCopyFromConventional?: () => void;
};

const ReducedCarbonHelperText: React.FC<ReducedProps> = ({
  onCopyFromConventional,
}) => {
  return (
    <Stack px={4} spacing={4}>
      <Typography>
        Select an Internal energy production or External energy providers you
        would like to utilize in this build.
      </Typography>
      <Typography>Low Carbon builds do not use natural gas.</Typography>
      <Typography>
        Try to keep your Annual Emissions low to maximize your decreased carbon
        impact.
      </Typography>
      <Typography>
        Note: You may pull in Low Carbon compatible elements from your previous
        build.
      </Typography>
      <Stack px={16}>
        <Button
          color={'success'}
          variant='contained'
          onClick={onCopyFromConventional}
        >
          RE-USE PREVIOUS BUILD
        </Button>
      </Stack>
    </Stack>
  );
};

type ZeroProps = {
  onCopyFromReduced?: () => void;
};

const ZeroCarbonHelperText: React.FC<ZeroProps> = ({ onCopyFromReduced }) => {
  return (
    <Stack px={4} spacing={4}>
      <Typography>
        Select an Internal energy production or External energy providers you
        would like to utilize in this build.
      </Typography>
      <Typography>
        Zero Carbon builds do not use natural gas or any energy production
        sources that produce emissions.
      </Typography>
      <Typography>
        Note: You may pull in Zero Carbon compatible elements from your previous
        build.
      </Typography>
      <Stack px={16}>
        <Button
          color={'success'}
          variant='contained'
          onClick={onCopyFromReduced}
        >
          RE-USE PREVIOUS BUILD
        </Button>
      </Stack>
    </Stack>
  );
};
